import { createEvent, createStore } from 'effector';

export const searchChangeEvent = createEvent<{
  search?: boolean;
  placeholder?: string;
}>();

export interface SearchState {
  search: boolean;
  placeholder: string;
}

export const initialSearchState: SearchState = {
  search: false,
  placeholder: 'Search docs, tasks, files and other with AI',
};

export const $searchState = createStore(initialSearchState).on(searchChangeEvent, (state, update) => {
  return {
    ...state,
    ...update,
  };
});

export const $searchOpen = $searchState.map((state) => state.search);
export const $searchPlaceholder = $searchState.map((state) => state.placeholder);
